var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimelinePattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-33",
    fill: "#D1F1F5",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9813826,13.6 C16.9366086,8.98102568 3.90801419,9.83103605 0.0143159465,6.31189141 C0.0143159465,4.90597152 -0.0147004029,4.14460513 0.00988669477,3.2 C3.35776285,6.58928542 16.6563431,5.93462656 19.9813826,10.3705261 C19.9802111,11.5431229 20.0238515,12.3956601 19.9813826,13.6 Z",
    id: "Rectangle-Copy-184",
    fill: "#007C92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,20 C16.4630357,15.4182433 3.47903863,17.1399891 0,13.6054518 C0.00161931764,11.343383 0.00685974687,11.5883349 0,10.4 C3.64284356,13.9944965 16.0133465,12.3375576 20,16.801034 C19.9988266,17.9625536 19.9926366,18.4386519 20,20 Z",
    id: "Rectangle-Copy-185",
    fill: "#007C92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,6.4 C15.5423903,1.3023923 7.59645213,4.19677701 -7.27595761e-13,8.21467026e-13 C2.26767647,-0.00999390363 5.91798975,-0.00584651853 9.38491725,0.00669979254 C12.7310303,0.529376614 17.876899,0.529376614 19.995374,3.25434908 C19.9927717,4.2034768 20,4.91930746 20,6.4 Z",
    id: "Rectangle-Copy-186",
    fill: "#007C92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,20 C0,18.8185826 0.00514163618,17.7149952 0,16.8 C1.47479915,17.9785445 5.16294269,19.3630695 9.38837501,20 C13.6138073,20.6369305 2.29379736,19.9891149 0,20 Z",
    id: "Rectangle-Copy-187",
    fill: "#007C92"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelinePattern);
export default __webpack_public_path__ + "static/media/timeline-pattern.fd6401420f856fb65a35dfe3db493e36.svg";
export { ForwardRef as ReactComponent };